import PropTypes from 'prop-types';
import React from 'react';
import LoginModal from '../login/LoginModal';
import { useAuth } from '../../../../checkout/hooks/useAuth';
export default function UserIcon(_ref) {
  var {
    customer,
    accountUrl,
    loginApi,
    generateOtpApi,
    verifyOtpApi,
    resetPasswordApi,
    updatePasswordApi,
    createCustomerApi
  } = _ref;
  var [open, setOpen] = React.useState(false);
  var {
    customer: authCustomer
  } = useAuth();
  var currentCustomer = authCustomer !== null && authCustomer !== void 0 ? authCustomer : customer;
  React.useEffect(() => {
    if (currentCustomer && open) {
      setOpen(false);
    }
  }, [currentCustomer, open]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "self-center hidden lg:block mt-4 scale-105"
  }, customer ? /*#__PURE__*/React.createElement("a", {
    href: accountUrl,
    "aria-label": "Account"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6484 19.8776C20.2206 17.4091 18.0203 15.6391 15.4525 14.8001C16.7226 14.0439 17.7094 12.8917 18.2614 11.5205C18.8134 10.1492 18.8999 8.63468 18.5078 7.20945C18.1157 5.78422 17.2666 4.52711 16.0909 3.63117C14.9151 2.73523 13.4778 2.25 11.9996 2.25C10.5215 2.25 9.08414 2.73523 7.90842 3.63117C6.73269 4.52711 5.88358 5.78422 5.49146 7.20945C5.09935 8.63468 5.18592 10.1492 5.73788 11.5205C6.28984 12.8917 7.27668 14.0439 8.54683 14.8001C5.97902 15.6382 3.77871 17.4082 2.35089 19.8776C2.29853 19.9629 2.2638 20.0579 2.24875 20.1569C2.2337 20.256 2.23863 20.357 2.26326 20.4541C2.28789 20.5511 2.33171 20.6423 2.39214 20.7222C2.45257 20.802 2.52838 20.869 2.6151 20.9191C2.70183 20.9692 2.79771 21.0014 2.89709 21.0138C2.99647 21.0263 3.09733 21.0187 3.19373 20.9915C3.29012 20.9643 3.3801 20.9181 3.45835 20.8556C3.5366 20.7931 3.60154 20.7156 3.64933 20.6276C5.41558 17.5751 8.53746 15.7526 11.9996 15.7526C15.4618 15.7526 18.5837 17.5751 20.35 20.6276C20.3977 20.7156 20.4627 20.7931 20.5409 20.8556C20.6192 20.9181 20.7092 20.9643 20.8056 20.9915C20.902 21.0187 21.0028 21.0263 21.1022 21.0138C21.2016 21.0014 21.2975 20.9692 21.3842 20.9191C21.4709 20.869 21.5467 20.802 21.6072 20.7222C21.6676 20.6423 21.7114 20.5511 21.736 20.4541C21.7607 20.357 21.7656 20.256 21.7505 20.1569C21.7355 20.0579 21.7008 19.9629 21.6484 19.8776ZM6.74964 9.00255C6.74964 7.9642 7.05755 6.94917 7.63443 6.08581C8.21131 5.22245 9.03124 4.54954 9.99056 4.15218C10.9499 3.75482 12.0055 3.65086 13.0239 3.85343C14.0423 4.056 14.9777 4.55601 15.712 5.29024C16.4462 6.02447 16.9462 6.95993 17.1488 7.97833C17.3513 8.99673 17.2474 10.0523 16.85 11.0116C16.4527 11.971 15.7797 12.7909 14.9164 13.3678C14.053 13.9446 13.038 14.2526 11.9996 14.2526C10.6077 14.2511 9.27322 13.6975 8.28898 12.7132C7.30473 11.729 6.75113 10.3945 6.74964 9.00255Z",
    fill: "white"
  })))) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": "Login",
    className: "bg-transparent border-0 p-0 cursor-pointer",
    onClick: () => setOpen(true)
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6484 19.8736C20.2206 17.4052 18.0203 15.6352 15.4525 14.7961C16.7226 14.04 17.7094 12.8878 18.2614 11.5166C18.8134 10.1453 18.8999 8.63077 18.5078 7.20554C18.1157 5.78031 17.2666 4.5232 16.0909 3.62726C14.9151 2.73132 13.4778 2.24609 11.9996 2.24609C10.5215 2.24609 9.08414 2.73132 7.90842 3.62726C6.73269 4.5232 5.88358 5.78031 5.49146 7.20554C5.09935 8.63077 5.18592 10.1453 5.73788 11.5166C6.28984 12.8878 7.27668 14.04 8.54683 14.7961C5.97902 15.6343 3.77871 17.4043 2.35089 19.8736C2.29853 19.959 2.2638 20.054 2.24875 20.153C2.2337 20.2521 2.23863 20.3531 2.26326 20.4502C2.28789 20.5472 2.33171 20.6384 2.39214 20.7183C2.45257 20.7981 2.52838 20.8651 2.6151 20.9152C2.70183 20.9653 2.79771 20.9975 2.89709 21.0099C2.99647 21.0224 3.09733 21.0148 3.19373 20.9876C3.29012 20.9604 3.3801 20.9142 3.45835 20.8517C3.5366 20.7892 3.60154 20.7117 3.64933 20.6236C5.41558 17.5711 8.53746 15.7486 11.9996 15.7486C15.4618 15.7486 18.5837 17.5711 20.35 20.6236C20.3977 20.7117 20.4627 20.7892 20.5409 20.8517C20.6192 20.9142 20.7092 20.9604 20.8056 20.9876C20.902 21.0148 21.0028 21.0224 21.1022 21.0099C21.2016 20.9975 21.2975 20.9653 21.3842 20.9152C21.4709 20.8651 21.5467 20.7981 21.6072 20.7183C21.6676 20.6384 21.7114 20.5472 21.736 20.4502C21.7607 20.3531 21.7656 20.2521 21.7505 20.153C21.7355 20.054 21.7008 19.959 21.6484 19.8736ZM6.74964 8.99864C6.74964 7.96029 7.05755 6.94526 7.63443 6.0819C8.21131 5.21854 9.03124 4.54564 9.99056 4.14828C10.9499 3.75092 12.0055 3.64695 13.0239 3.84952C14.0423 4.05209 14.9777 4.55211 15.712 5.28633C16.4462 6.02056 16.9462 6.95602 17.1488 7.97442C17.3513 8.99282 17.2474 10.0484 16.85 11.0077C16.4527 11.967 15.7797 12.787 14.9164 13.3639C14.053 13.9407 13.038 14.2486 11.9996 14.2486C10.6077 14.2472 9.27322 13.6936 8.28898 12.7093C7.30473 11.7251 6.75113 10.3906 6.74964 8.99864Z",
    fill: "white"
  })))), !customer && /*#__PURE__*/React.createElement(LoginModal, {
    open: open,
    onClose: () => setOpen(false),
    loginApi: loginApi,
    generateOtpApi: generateOtpApi,
    verifyOtpApi: verifyOtpApi,
    resetPasswordApi: resetPasswordApi,
    updatePasswordApi: updatePasswordApi,
    createCustomerApi: createCustomerApi
  }));
}
UserIcon.propTypes = {
  accountUrl: PropTypes.string,
  customer: PropTypes.shape({
    email: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    uuid: PropTypes.string.isRequired
  }),
  createCustomerApi: PropTypes.string.isRequired,
  generateOtpApi: PropTypes.string.isRequired,
  loginApi: PropTypes.string.isRequired,
  resetPasswordApi: PropTypes.string.isRequired,
  updatePasswordApi: PropTypes.string.isRequired,
  verifyOtpApi: PropTypes.string.isRequired
};
UserIcon.defaultProps = {
  accountUrl: null,
  customer: null
};
;
export var query = "\n  query Query {\n    customer: currentCustomer {\n      uuid\n      fullName\n      email\n    }\n    accountUrl: url(routeId: \"account\")\n    loginApi: url(routeId: \"customerLoginJson\")\n    generateOtpApi: url(routeId: \"generateOtp\")\n    verifyOtpApi: url(routeId: \"verifyOtp\")\n    resetPasswordApi: url(routeId: \"resetPassword\")\n    updatePasswordApi: url(routeId: \"updatePassword\")\n    createCustomerApi: url(routeId: \"createCustomer\")\n  }\n";